// Escada de faixas HORÁRIAS - o eixo que substitui "faixa de vencimento" no
// Flow.Sight de FX Spot.
//
// Por que horário e não liquidação: o relatório de spot tem `sett_brl`
// (d+0/d+1/d+2), que é o análogo literal do prazo, mas 985 das 1052 linhas do
// universo de conversão caem em `d+1` - um eixo com uma barra gigante e três
// vazias. A hora do RFQ, por outro lado, distribui-se em cinco faixas povoadas
// e separa comportamento: a conversão por volume vai de 21,7% a 51,7% entre
// elas, e as rejeições por "desk offline" caem monotonicamente ao longo do dia
// (249, 252, 187, 138, 136, 85, 62, 20 por hora). É causal, não decorativo.
//
// Mesma forma de API da escada de vencimento em `flowSightBuckets.js`, de
// propósito: os construtores de chart do fxspot são cópias dos do fxndf e a
// troca é ponto a ponto.
//
// `max` é a última hora INCLUÍDA na faixa (hora cheia, 0-23).

export const HOUR_BUCKETS = [
  { label: '<10h', max: 9 },
  { label: '10-12h', max: 11 },
  { label: '12-14h', max: 13 },
  { label: '14-16h', max: 15 },
  { label: '16h+', max: Infinity },
]

export const HOUR_LABELS = HOUR_BUCKETS.map((b) => b.label)

// Extremos do eixo contínuo (a raia de bolhas do Portfólio). Não são 0 e 24: o
// export de referência tem 4750 das 4752 linhas entre 08h e 17h, e abrir o eixo
// no dia inteiro espremeria tudo no meio.
export const HOUR_AXIS_MIN = 8
export const HOUR_AXIS_MAX = 18

export const hourIndexFromHour = (hour) => {
  const h = Number(hour)
  if (!Number.isFinite(h)) return 0
  const i = HOUR_BUCKETS.findIndex((b) => h <= b.max)
  return i === -1 ? HOUR_BUCKETS.length - 1 : i
}

export const hourLabelFromHour = (hour) => HOUR_BUCKETS[hourIndexFromHour(hour)].label

// Hora cheia de um timestamp de RFQ, ou null quando não dá para saber.
// Aceita Date e string, porque a linha passa por dois caminhos: o mapeamento do
// relatório (string crua) e `normalizeRow` (já convertido para Date).
export function hourOfDayFrom (value) {
  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : value.getHours()
  }
  const m = /[T ](\d{2}):/.exec(String(value || ''))
  return m ? Number(m[1]) : null
}
